import { MapPin, CheckCircle2 } from "lucide-react";

const AreasSection = () => {
  const postcodes = [
    { code: "S1", areas: "City Centre" },
    { code: "S2", areas: "City Centre" },
    { code: "S3", areas: "City Centre" },
    { code: "S6", areas: "Hillsborough, Walkley" },
    { code: "S7", areas: "Nether Edge, Millhouses" },
    { code: "S8", areas: "Lowedges, Greenhill" },
    { code: "S10", areas: "Ranmoor, Fulwood, Broomhill" },
    { code: "S11", areas: "Ecclesall, Whirlow, Bents Green" },
    { code: "S17", areas: "Dore, Totley, Bradway" },
    { code: "S18", areas: "Dronfield, Coal Aston" },
    { code: "S35", areas: "Ecclesfield, Grenoside" },
    { code: "S36", areas: "Stocksbridge, Deepcar" },
  ];

  const studentAreas = [
    "Sheffield Hallam University",
    "University of Sheffield",
    "Student Accommodation",
  ];

  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="py-20 lg:py-32 bg-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 bg-[#EFF6FF] rounded-full px-4 py-2 mb-6">
            <MapPin className="w-4 h-4 text-[#3B82F6]" />
            <span className="text-sm font-medium text-[#3B82F6]">Sheffield Coverage</span>
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4 tracking-tight"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Areas We Cover
          </h2>
          <p className="text-lg text-[#64748B] max-w-2xl mx-auto">
            Proudly serving homes and businesses across Sheffield and surrounding areas.
          </p>
        </div>

        {/* Postcodes Grid */}
        <div className="grid sm:grid-cols-3 lg:grid-cols-3 gap-4 mb-12">
          {postcodes.map((postcode) => (
            <div
              key={postcode.code}
              data-testid={`postcode-${postcode.code.toLowerCase()}`}
              className="flex items-center justify-between bg-[#F8FAFC] hover:bg-[#EFF6FF] border border-slate-100 hover:border-[#3B82F6]/30 rounded-xl px-5 py-4 transition-all duration-200 area-tag cursor-default group"
            >
              <div className="flex items-center gap-3">
                <CheckCircle2 className="w-5 h-5 text-[#3B82F6] group-hover:text-white transition-colors" />
                <span className="font-bold text-xl text-[#0F172A] group-hover:text-white transition-colors">{postcode.code}</span>
              </div>
              <span className="text-sm text-[#64748B] group-hover:text-white/80 transition-colors">
                {postcode.areas}
              </span>
            </div>
          ))}
        </div>

        {/* Student Areas */}
        <div className="bg-gradient-to-r from-[#EFF6FF] to-[#F8FAFC] rounded-2xl p-8 border border-[#3B82F6]/10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h3 
                className="text-xl font-bold text-[#0F172A] mb-2"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                Student Accommodation Specialists
              </h3>
              <p className="text-[#64748B]">
                Move-in and move-out cleaning services for students near Sheffield's universities.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              {studentAreas.map((area) => (
                <span
                  key={area}
                  className="inline-flex items-center gap-2 bg-white border border-[#3B82F6]/20 text-[#0F172A] px-4 py-2 rounded-full text-sm font-medium shadow-sm"
                >
                  <MapPin className="w-4 h-4 text-[#3B82F6]" />
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Seasonal note */}
        <div className="mt-12 text-center">
          <p className="text-[#64748B] text-sm">
            <span className="font-semibold text-[#0F172A]">Peak seasons:</span> Student move-out (May-June) • Student move-in (Aug-Sept) • Spring cleaning (Feb-Mar) • Christmas prep (Nov-Dec)
          </p>
        </div>
      </div>
    </section>
  );
};

export default AreasSection;
